export default {"src":"/login-app/[GIT_HASH]/_next/static/media/priority_4.50ec506f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};